// extracted by mini-css-extract-plugin
export default {"panel":"Contact_panel__9WTIs","glow":"Contact_glow__xxCvj","copy":"Contact_copy__eoPa+","actions":"Contact_actions__u7zBo"};